<template>
  <a href="#" @click.prevent="$emit('on-play')">
    <span v-if="title">{{title}}</span>
    <template v-else>
      <div v-if="loading" class="loading"></div>

      <SvgIcon v-else-if="playing" icon="playing" class="o-channel__icon" />
      <SvgIcon v-else icon="play-new" class="o-channel__icon o-channel__play" small />
    </template>
  </a>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Play',
  props: [
    'title',
    'channel',
  ],
  computed: {
    ...mapState({
      loading: function(state) {
        return state.radioplayer.activeChannel === this.channel && state.radioplayer.buffering;
      },
      playing: function(state) {
        return state.radioplayer.activeChannel === this.channel && !state.radioplayer.buffering;
      },
    }),
  },
}
</script>
